import { render } from "./EditPageTranslate.vue?vue&type=template&id=4b172383&scoped=true"
import script from "./EditPageTranslate.vue?vue&type=script&lang=js"
export * from "./EditPageTranslate.vue?vue&type=script&lang=js"

import "./EditPageTranslate.vue?vue&type=style&index=0&id=4b172383&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b172383"]])

export default __exports__